<div class="container">
  <div class="pt-10 borderbottomForTab pb-10">


              <mat-form-field class="w-100 mw-sm-175 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                  (selectionChange)="viewAssetYear($event.value,'allDashBoard')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

  </div>

  <ion-row class="pt-10">
    <!-- <ion-col size="12" size-md="6" size-lg="3">
      <div class="card phi-flex-center phi-gap-15" (click)="onClickCard(1)">
 
        <div>
          <span class="material-icons" style="font-size: 36px; color: #3b82f6;">assignment_turned_in</span>
        </div>
        <div class="text-center">
          <p class="fs-12 font_semibold text-center">No. of given asset </p>
          <p class="mt-5 fs-16 fs_14ForMobile font_bold text_black cp">{{totalassetCountTop}}</p>
        </div>
        
      </div>
    </ion-col> -->
    
    <ion-col size="12" size-md="6" size-lg="3">
      <div class="card expense-card h-100" 
           [class.disabled-card]="totalassetCountTop <= 0"
           (click)="totalassetCountTop > 0 && onClickCard(1)">
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon">receipt_long</mat-icon>
            <div class="text-center">
              <p class="fs-12 font_semibold expense-title">No. of given asset</p>
              <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
                {{ totalassetCountTop }}
              </p>
            </div>
        </div>
      </div>
    </ion-col>

   <ion-col size="12" size-md="6" size-lg="3">
      <div
        class="card expense-card h-100"
        [class.disabled-card]="newAssetTotalLength <= 0"
        (click)="newAssetTotalLength > 0 && onClickCard(2)"
      >
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon not-given-icon">inventory</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold expense-title">No. of not given asset</p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ newAssetTotalLength || 0 }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6" size-lg="3">
      <div
        class="card expense-card h-100"
        [class.disabled-card]="totalrepairedAsset <= 0"
        (click)="totalrepairedAsset > 0 && onClickCard(3)"
      >
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon repaired-icon">build_circle</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold expense-title">No. of repaired asset</p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ totalrepairedAsset || 0 }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>
    
     <ion-col size="12" size-md="6" size-lg="3">
      <div
        class="card expense-card h-100"
        [class.disabled-card]="totalCountRecivedAsset <= 0"
        (click)="totalCountRecivedAsset > 0 && onClickCard(4)"
      >
        <div class="phi-flex-center phi-gap-12">
          <mat-icon class="expense-icon received-icon">assignment_return</mat-icon>
          <div class="text-center">
            <p class="fs-12 font_semibold expense-title">
              No. of received asset After Exit
            </p>
            <p class="mt-5 fs-12 font_bold Cerulean-black cp expense-count">
              {{ totalCountRecivedAsset || 0 }}
            </p>
          </div>
        </div>
      </div>
    </ion-col>

  </ion-row>


  
  <ion-row class="pt-10">
    <ion-col size="12" size-md="6">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Asset Employee Count</div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)=" switchAssettypeGraph('bar')">
                <img *ngIf="isAssetTypeIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchReimbursementTypeTable()">
                <img *ngIf="!isAssetTypeTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)=" switchAssettypeGraph('line')">
                <img *ngIf="isAssetTypeIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isAssetTypeIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset-Employee-Count')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <!-- <ion-row>
            <div class="d-flex "> -->
              
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset1"
                  (selectionChange)="viewAssetYear($event.value,'first')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>


            <!-- </div>
          </ion-row> -->
        </div>

 
        <!-- <div> -->
          <div [ngClass]="{'dispNone' : !isAssetTypeTable}">
            <div class="dashboardGraphTable table-container">
              <table id="asset-type-table-data">
                <thead>
                  <tr class="custom-size">
                    <th>Asset Name </th>
                    <th> Employee Count</th>

                    
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAsseTableGraphOne">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isAssetTypeTable}" id="bar-line-chart-for-asset" style="width: 100%; height: 400px;"></div>
        <!-- </div> -->
      </div>
    </ion-col>
    <ion-col size="12" size-md="6">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Asset Repaired Day Count</div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchrepaiedAssetGraph('bar')">
                <img *ngIf="isRepairedByAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
              </span>
              <span (click)="switchrepaiedAssetGraphForTable()">
                <img *ngIf="!isRepairedByAssetTable" src="././assets/icon/tableIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchrepaiedAssetGraph('line')">
                <img *ngIf="isRepairedByAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="" class="cp">
                <img *ngIf="isRepairedByAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Resolution')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <!-- <ion-row> -->
            <!-- <div class="d-flex "> -->
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset2"
                  (selectionChange)="viewAssetYear($event.value,'second')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>


              </mat-form-field>
              <!-- First Date Range Picker -->
 
            <!-- </div> -->
          <!-- </ion-row> -->
        </div>
      
        <div>
          <div [ngClass]="{'dispNone' : !isRepairedByAssetTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-Asset-Resolution-data">
                <thead>
                  <tr class="custom-size">

                    <th>Asset Name</th>
                    <th>Asset repaired Day</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAsseTableGraphTwo">

                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}} {{'Days'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isRepairedByAssetTable}" id="bar-line-repaired-chart" style="width: 100%; height: 400px;"></div>
        </div>


      </div>
    </ion-col>
  </ion-row>

  <!-- second row for graph -->
  <ion-row class="pt-10">
    <ion-col size="12" size-md="6">
      <div class="graphs m-50">
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Asset Repaired Count</div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchhowManyTimeRepairedAsset('bar')">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                  alt="">
              </span>
              <span (click)="switchhowManyTimeRepairedAssetTable()">
                <img *ngIf="!isswitchhowManyTimeRepairedAssetTable" src="././assets/icon/tableIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchhowManyTimeRepairedAsset('line')">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                  alt="" class="cp">
                <img *ngIf="isswitchhowManyTimeRepairedAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                  alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Repaired Count')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10">
          <!-- <ion-row> -->
            <!-- <div class="d-flex "> -->
              <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset3"
                  (selectionChange)="viewAssetYear($event.value,'third')">
                  <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                    {{sharedService.transformYearToFyFormat(item.year)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>



            <!-- </div> -->
          <!-- </ion-row> -->
        </div>

        <div>
          <div [ngClass]="{'dispNone' : !isswitchhowManyTimeRepairedAssetTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-data-asset-repaired-count">
                <thead>
                  <tr class="custom-size">
                    <th>Asset Name </th>
                    <th>Asset Repaired Count</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAssetTableGraphThird">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isswitchhowManyTimeRepairedAssetTable}" id="bar-line-asset-repaired-chart" style="width: 100%; height: 400px;"></div>
        </div>
      </div>
    </ion-col>
    <ion-col size="12" size-md="6"style="display: none;">
      <div class="graphs m-50" >
        <ion-row class="justify-content-center">
          <ion-col size="12" size-md="7">
            <div class="fs-16 fs_14ForMobile font_bold">Asset Allocation Time</div>
          </ion-col>
          <ion-col size="12" size-md="5">
            <div class="d-flex graph-icon">
              <span (click)="switchhowManyDaysToAssignAsset('bar')">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon == 'bar'" src="././assets/icon/BarGraphActive.svg"
                  alt="">
              </span>
              <span (click)="switchhowManyDaysToAssignAssetTable()">
                <img *ngIf="!isswitchhowManyDaysToAssignAssetTable" src="././assets/icon/tableIcon.svg" alt=""
                  class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetTable" src="././assets/icon/TableIconActive.svg" alt="">
              </span>
              <span (click)="switchhowManyDaysToAssignAsset('line')">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon != 'line'" src="././assets/icon/lineChartIcon.svg"
                  alt="" class="cp">
                <img *ngIf="isswitchhowManyDaysToAssignAssetIcon == 'line'" src="././assets/icon/activeLineChart.svg"
                  alt="">
              </span>
              <span>
                <img (click)="downloadChartAsPDF('Asset Allocation Time')" src="././assets/icon/downloadIcon.svg" alt=""
                  class="cp">
              </span>
            </div>
          </ion-col>
        </ion-row>
        <div class="mt-10 mb-10 phi-flex-wrap-center phi-gap-12">
          <!-- <ion-row> -->
            <!-- <div class="d-flex "> -->
              <!-- <div class=mw-sm-250> -->
                <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
                  <mat-select placeholder="Select" [(ngModel)]="selectedYearForAsset4"
                    (selectionChange)="viewAssetYear($event.value,'fourth')">
                    <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                      {{sharedService.transformYearToFyFormat(item.year)}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              <!-- </div> -->

              <!-- <div class=mw-sm-250> -->
                <ng-multiselect-dropdown class="w-100 mw-sm-250" [placeholder]="'Select Authority'" [settings]="dropdownSettings"
                  [data]="getListForAuthority" [(ngModel)]="selectedAuthority" (onSelect)="onSelectAuthority()"
                  (onDeSelect)="onDelectAuthority()" (onSelectAll)="selectAllAuthority($event)"
                  (onDeSelectAll)="onDeSelectAllAuthority()">
                </ng-multiselect-dropdown>
              <!-- </div> -->

            <!-- </div> -->
          <!-- </ion-row> -->
        </div>


        <div>
          <div [ngClass]="{'dispNone' : !isswitchhowManyDaysToAssignAssetTable}">
            <div class="dashboardGraphTable table-container">
              <table id="table-data-asset-allocatin-count">
                <thead>
                  <tr class="custom-size">
                    <th>Expense Type </th>
                    <th>Amout paid by finance</th>

                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of isAssetTableGraphFourth">
                    <td>{{data.xAxisValueData}}</td>
                    <td>{{data.seriesValueOneData}} {{'Days'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div [ngClass]="{'dispNone' : isswitchhowManyDaysToAssignAssetTable}" id="bar-line-asset-allocatiom-chart"style="width: 100%; height: 400px;"></div>
        </div>
      </div>
    </ion-col>
  </ion-row>


  <!-- fourth -->
  <ion-row class="pt-10">


  </ion-row>
</div>